module.exports = __webpack_public_path__ + "static/media/level-up-alt.a1963a78.svg";